export default __webpack_public_path__ + "static/media/lets-go-img.da808a98.png";